var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 13C27.7348 13 27.4804 13.1054 27.2929 13.2929C27.1054 13.4804 27 13.7348 27 14V22C27 22.2652 26.8946 22.5196 26.7071 22.7071C26.5196 22.8946 26.2652 23 26 23H6C5.73478 23 5.48043 22.8946 5.29289 22.7071C5.10536 22.5196 5 22.2652 5 22V14C5 13.7348 4.89464 13.4804 4.70711 13.2929C4.51957 13.1054 4.26522 13 4 13C3.73478 13 3.48043 13.1054 3.29289 13.2929C3.10536 13.4804 3 13.7348 3 14V22C3.0007 22.7954 3.31723 23.5579 3.88 24.12C4.44207 24.6828 5.20462 24.9993 6 25H26C26.7954 24.9993 27.5579 24.6828 28.12 24.12C28.6828 23.5579 28.9993 22.7954 29 22V14C29 13.7348 28.8946 13.4804 28.7071 13.2929C28.5196 13.1054 28.2652 13 28 13Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3998 18.8C15.5729 18.9298 15.7834 19 15.9998 19C16.2162 19 16.4267 18.9298 16.5998 18.8L28.4098 9.94C28.5941 9.80107 28.7246 9.6027 28.7793 9.37852C28.8339 9.15434 28.8094 8.91815 28.7098 8.71C28.5609 8.40232 28.3615 8.12177 28.1198 7.88C27.5577 7.31723 26.7952 7.0007 25.9998 7H5.99981C5.20443 7.0007 4.44188 7.31723 3.87981 7.88C3.63817 8.12177 3.43874 8.40232 3.28981 8.71C3.19023 8.91815 3.1657 9.15434 3.22038 9.37852C3.27505 9.6027 3.40558 9.80107 3.58981 9.94L15.3998 18.8ZM5.99981 9H25.9998C26.0926 8.98539 26.1871 8.98539 26.2798 9L15.9998 16.75L5.71981 9C5.81258 8.98539 5.90705 8.98539 5.99981 9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.6b5dcd102899e2ae4290887b3db88f47.svg";
export { ForwardRef as ReactComponent };